"use client";
import { useState, useEffect } from "react";
import Image from "next/image";
import Slider from "react-slick";
import Link from "next/link";
import { getApiBaseUrl } from "@/lib/apiBase";
const BASE_URL = getApiBaseUrl();

export default function MoreAdvices() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const settings = {
    dots: true,
    infinite: true,
    speed: 600,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 4000,
    arrows: false,
    appendDots: (dots) => (
      <div
        style={{ position: "absolute", bottom: "-25px", width: "100%" }}
        className="flex justify-center"
      >
        <ul className="flex gap-2 p-0 m-0 list-none">{dots}</ul>
      </div>
    ),
    customPaging: () => (
      <div className="w-3 h-3 bg-gray-300 rounded-full hover:bg-[#577099] transition-all"></div>
    ),
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 5 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 4 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2 },
      },
    ],
  };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetch(`/api/chanaradvicecategory?type=advice`);
        const data = await response.json();
        setCategories(data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  if (loading) {
    return (
      <div className="max-w-[1440px] mx-auto px-4 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-[250px] bg-gray-200 rounded-lg animate-pulse"></div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-[1440px] mx-auto px-4 py-6">
      <div className="relative w-full h-auto rounded-xl overflow-hidden">
        <Slider {...settings}>
          {categories.map((category) => (
            <div key={category.id} className="px-2">
              <Link href={`/chanaradvice/${category.id}`}>
                <div className="bg-white rounded-lg shadow-lg overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-90 hover:shadow-2xl">
                  <div className="relative w-full h-[180px] md:h-[200px] overflow-hidden">
                    <Image
                      src={`${BASE_URL}${category.image}`}
                      alt={category.name}
                      fill
                      className="object-cover transition-transform duration-700 ease-out group-hover:scale-110"
                    />
                  </div>
                  <div className="p-2 md:p-3">
                    <h3 className="text-xs md:text-sm font-semibold line-clamp-2 text-gray-700 text-center transition-transform duration-700 group-hover:translate-y-1">
                      {category.name}
                    </h3>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}
